import { getToken } from 'applicaiton/sessionStorage/auth';
import axios from 'axios';
import { ApplicationType, x_app_type } from '../../applicaiton';

/**
 * Create an Axios instance with the specified base URL.
 * @returns The created Axios instance
 */
const axiosTokenInstance = () => {
  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
  });

  /**
   * Add a request interceptor to the Axios instance.
   * If there is a token in the session storage, add it to the Authorization header of the request.
   * @param config - The configuration object for the current request
   * @returns The modified configuration object with additional headers
   */
  axiosInstance.interceptors.request.use(
    async function (config) {
      return {
        ...config,
        ...(getToken()
          ? {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-type': 'Application/json',
                Authorization: `Bearer ${getToken()}`,
                [x_app_type]: ApplicationType.ProfessionalWeb,
              },
            }
          : {}),
      };
    },
    function (error) {
      return Promise.reject(error);
    },
  );

  return axiosInstance;
};

/**
 * Export the created Axios instance as a default export.
 */
export default axiosTokenInstance;
